import {
  Box,

  Typography,
  Card,
  CardContent,
  CircularProgress,
} from "@mui/material";
import {
  School as SchoolIcon,
} from "@mui/icons-material";

import { useEffect, useState } from "react";
import ClassroomSelection from "./classroom-selection";
import StudentsTable from "./students-table";
import NavBarLayout from "../../components/nav-bar-layout";
import { useClassroomActions } from "../../hooks/useClassroomActions";

function Students() {  
  const {classrooms, getClassrooms, getStudents, unEnrollStudents } = useClassroomActions();

  const [selectedClassroomId, setSelectedClassroomId] = useState(0);

  const selectedClassroom = classrooms?.[selectedClassroomId];

  const [tracker, setTracker] = useState<Record<number, boolean>>({});

  const [loading, setLoading] = useState(false);

  const fetchStudents = async (reset: boolean = false) => {
    if (!reset && selectedClassroomId in tracker && !tracker[selectedClassroomId]) {
      return;
    }
  
    if (reset || !(selectedClassroomId in tracker)) {
      setTracker(prev => ({
        ...prev,
        [selectedClassroomId]: true
      }));
    }

    const newLength = await getStudents(selectedClassroomId, reset) || 0;

    setTracker(prev => ({
      ...prev,
      [selectedClassroomId]: newLength < 50 ? false : true
    }));
  };

  useEffect(() => {
    const loadData = async () => {
      if (selectedClassroomId === 0 || selectedClassroom && selectedClassroom.enrollments) return;

      setLoading(true);
      await fetchStudents();
      setLoading(false);
    };

    loadData();
  }, [selectedClassroomId]);

  useEffect(() => {
    const loadClassrooms = async () => {
      if (classrooms) return;
      await getClassrooms();
    };

    loadClassrooms();
  }, [classrooms]);

  
  return (
    <NavBarLayout>

      {classrooms && (
        <ClassroomSelection
          classrooms={classrooms}
          selectedClassroomId={selectedClassroomId}
          setSelectedClassroomId={setSelectedClassroomId}
        />
      )}
      

        {selectedClassroomId !== 0 && (
          <Box sx={{ mt: 3 }}>
            {loading && (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                <CircularProgress />
              </Box>
            )}

            {!loading && selectedClassroom && selectedClassroom.enrollments && (
              <StudentsTable
                selectedClassroom={selectedClassroom}
                fetchStudents={fetchStudents}
                tracker={tracker}
              />
            )}

          </Box>
        )}

        {selectedClassroomId === 0 && (
          <Card 
            elevation={0} 
            sx={{ 
              border: "2px dashed", 
              borderColor: "divider",
              textAlign: "center",
              py: 8,
              mt: 4
            }}
          >
            <CardContent>
              <SchoolIcon sx={{ fontSize: 64, color: "text.secondary", mb: 2, opacity: 0.5 }} />
              <Typography variant="h5" gutterBottom color="text.secondary">
                Select a Classroom
              </Typography>
              <Typography variant="body1" color="text.secondary" maxWidth={400} mx="auto">
                Choose a classroom from the dropdown above to view and manage student enrollments.
              </Typography>
            </CardContent>
          </Card>
        )}


    
    </NavBarLayout>
  );
}

export default Students;